import {ModalitaPagamentoExtraSepaForm} from "../../models/form/modalita-pagamento-extra-sepa-form.model";

export const modalitaPagamentoExtraSepaFormDefaults: ModalitaPagamentoExtraSepaForm = {
	existsDelegatoRiscossione: false,
	swift: null,
	banca: null,
	indirizzo: null,
	codiceContoPresent: false,
	codiceConto: null,
	iban: null,
	swiftBicPresent: false,
	nazione: null,
	citta: null,
	zipCode: null
}
